import Button from '../buttons/cardButton';
import Container from '../../atoms/container/mosaicCardInfoContainer';
import Content from '../../../../shared/types/enums/content';
import FastEvent from '@shared/classes/fastEvent';
import Info from '../../atoms/text/cardInfoText';
import MediaProduction from '../../../../shared/classes/mediaProduction';
import Plan from '@shared/classes/plan';
import Setting from '../../../../shared/classes/setting';
import Title from '../../atoms/text/mosaicCardTitle';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { CardButtonIcon } from '@shared/types/enums/card';
import { useMemo } from 'react';

interface ButtonData {
  color?: string;
  display?: boolean;
  icon?: CardButtonIcon;
  text?: string;
}

interface Props {
  focused: boolean;
  item: MediaProduction | Setting;
  plan: Plan | null;
}

function MosaicCardInfo({ focused, item, plan }: Props) {
  const { button, info, title } = useMemo(() => {
    let button: ButtonData = {};
    let hasButton = false;
    let icon;
    let text = '';

    // Get card info

    const info =
      item.type === Content.MEDIA_PRODUCTION
        ? (item as MediaProduction)?.getSeasonNumber() +
          (item as MediaProduction)?.getEpisodeNumber()
        : '';

    // Get card title

    const title = TranslationManager.get(item?.title);

    // Get card button

    const color = plan?.colorHex;
    const display = !!(plan || focused);

    if (item.type !== 'setting') {
      if (plan) {
        hasButton = true;
        icon = CardButtonIcon.PLAN;
        text = focused
          ? TranslationManager.get('MISC.CARDS.SUBSCRIBE')
          : plan?.shortName;
      } else if (item instanceof FastEvent && !item.channel) {
        hasButton = true;
        icon = CardButtonIcon.INFO;
        text = TranslationManager.get('MISC.CARDS.MORE_INFO');
      } else if (
        item?.streams &&
        item?.type !== Content.SEASON &&
        item?.type !== Content.SERIES
      ) {
        hasButton = true;
        icon = CardButtonIcon.PLAY;
        text = TranslationManager.get('MISC.CARDS.VIEW_NOW');
      }
    }

    if (hasButton) {
      button = {
        color,
        display,
        icon,
        text,
      };
    }

    return { button, info, title };
  }, [focused, item, plan]);

  return (
    <Container info={!!(info || button)}>
      <Title>{title}</Title>
      <Info>{info}</Info>
      {button?.display ? (
        <Button
          color={button?.color}
          focused={focused}
          text={button?.text}
          iconType={button?.icon}
        />
      ) : null}
    </Container>
  );
}

export default MosaicCardInfo;
